import axios from "axios";

let baseURL = process.env.VUE_APP_BASE_URL || 'https://admin-backend.tommyjohn.com/'


export default axios.create({
  baseURL: baseURL,
  headers: {
    "Content-type": "application/json",
  }
});